var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSidemenuNoticeKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    fill: "#FFF",
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.1v.304l-.005.117a.589.589 0 0 1-.007.047.23.23 0 0 1-.04.1.134.134 0 0 1-.074.048.46.46 0 0 1-.114.012h-.676a.17.17 0 0 1-.138-.06.207.207 0 0 1-.05-.136l.002-.329.008-.281a1.13 1.13 0 0 1 .078-.41c.064-.125.144-.233.24-.322.096-.09.197-.17.304-.244a7.24 7.24 0 0 1 .32-.208c.107-.065.203-.137.288-.216a.996.996 0 0 0 .208-.27.781.781 0 0 0 .08-.368.796.796 0 0 0-.074-.342.879.879 0 0 0-.202-.276.962.962 0 0 0-.66-.254c-.12 0-.23.023-.328.068a.931.931 0 0 0-.446.422 1.1 1.1 0 0 0-.106.282.683.683 0 0 1-.13.258.32.32 0 0 1-.242.118H4.18c-.067 0-.112-.017-.136-.05A.237.237 0 0 1 4 5.004v-.116c.003-.275.058-.528.166-.76A1.88 1.88 0 0 1 4.6 3.53 2.067 2.067 0 0 1 5.988 3c.264 0 .515.045.752.136.237.09.446.217.626.378s.323.354.43.578c.107.224.16.468.16.732 0 .27-.036.495-.108.678a1.629 1.629 0 0 1-.27.464 1.826 1.826 0 0 1-.35.32c-.125.087-.242.17-.35.248a1.484 1.484 0 0 0-.27.248.481.481 0 0 0-.108.318zM5.416 8.728c0-.075.01-.139.03-.192.02-.053.069-.08.146-.08h.628c.032 0 .065.001.098.004a.29.29 0 0 1 .092.022c.028.012.051.03.07.052a.15.15 0 0 1 .028.098v.592c0 .037-.001.072-.004.104a.267.267 0 0 1-.022.088.136.136 0 0 1-.054.062.192.192 0 0 1-.1.022H5.7a.577.577 0 0 1-.212-.03c-.048-.02-.072-.07-.072-.15v-.592z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidemenuNoticeKey);
export default __webpack_public_path__ + "static/media/ic-sidemenu-notice-key.915ed000004833150b7046da27794fd9.svg";
export { ForwardRef as ReactComponent };